import {
  type ReactNode,
  type RefObject,
  useLayoutEffect,
  useState,
} from 'react'

// Whether `ref`'s box is hiding overflowing content (a line-clamp is cutting
// text). Re-measured whenever `content` changes, because a longer text inside a
// box that stays the same size never fires the ResizeObserver.
export const useIsClamped = (
  ref: RefObject<HTMLElement | null>,
  enabled: boolean,
  content: ReactNode,
): boolean => {
  const [clamped, setClamped] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!enabled || !element) {
      setClamped(false)
      return undefined
    }
    const measure = (): void =>
      setClamped(element.scrollHeight > element.clientHeight)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref, enabled, content])

  return clamped
}
